export default __webpack_public_path__ + "media/images/blue_heart-7d8e2bbe61bb9623fa91cf1f0ac651f0.png";